import agencyCommissionApi from "api/agencyCommissionApi";
import TransactionHistoryView from "features/ManageDealer/components/TransactionHistoryView";
import ListTransactionHistoryView from "features/ManageInvestor/components/ListTransactionHistoryView";
import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import KTBSCard from "general/components/OtherKeenComponents/KTBSCard";
import AppColors from "general/constants/AppColors";
import AppConfigs from "general/constants/AppConfigs";
import AppConstants from "general/constants/AppConstants";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function TransactionHistoryScreen() {
    const { user } = useSelector(state => state.auth);
    const [transactionList, setTransactionList] = useState([]);
    const [transactionTotal, setTransactionTotal] = useState(0);
    const [filterTransaction, setFilterTransaction] = useState({
        agencyId: '',
        q: '',
        from: '',
        to: '',
        status: '',
        page: 0,
        limit: AppConfigs.defaultPageLimit,
        forRole: ''
    });
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    useEffect(() => {
        handleGetTransactionList();
    }, [filterTransaction, user, adminRole]);

    const handleGetTransactionList = async () => {
        const agencyId = user?.agency?.agencyId || user?.agencyId;
        let params = {
            ...filterTransaction,
            agencyId,
        }
        params = _.pickBy(
            params,
            (value) => value !== null && value !== undefined && value !== ''
        )
        if (adminRole || !adminRole && params?.agencyId) {
            const transactionRes = await agencyCommissionApi.getAgencyCommissionTransactions(params);
            setTransactionList(transactionRes?.transactions || []);
            setTransactionTotal(Number(transactionRes?.total || 0));
        }
    };

    return (
        <div>
            <KTBSCard
                borderRadius={10}
                body={
                    <TransactionHistoryView
                        showFullUI={true}
                        agencyRole='SALE'
                        transactionList={transactionList}
                        transactionTotal={transactionTotal}
                        filter={filterTransaction}
                        onFilterChanged={(filter) => {
                            setFilterTransaction({
                                ...filterTransaction,
                                ...filter,
                            });
                        }}
                    />
                }
            />
        </div>
    );
}

export default TransactionHistoryScreen;
